<template>
  <div class="overlay-panel">
    <svg
      id="svg-spinner"
      xmlns="http://www.w3.org/2000/svg"
      width="96"
      height="96"
      viewBox="0 0 48 48"
    >
      <circle cx="24" cy="4" r="4" fill="#000" />
      <circle cx="12.19" cy="7.86" r="3.7" fill="#171717" />
      <circle cx="5.02" cy="17.68" r="3.4" fill="#2f2f2f" />
      <circle cx="5.02" cy="30.32" r="3.1" fill="#464646" />
      <circle cx="12.19" cy="40.14" r="2.8" fill="#5e5e5e" />
      <circle cx="24" cy="44" r="2.5" fill="#757575" />
      <circle cx="35.81" cy="40.14" r="2.2" fill="#8d8d8d" />
      <circle cx="42.98" cy="30.32" r="1.9" fill="#a4a4a4" />
      <circle cx="42.98" cy="17.68" r="1.6" fill="#bcbcbc" />
      <circle cx="35.81" cy="7.86" r="1.3" fill="#d3d3d3" />
    </svg>
  </div>
</template>
<script>
export default {
  name: "SpinnerLoading",
};
</script>
<style scoped>
.overlay-panel {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: #fff;
  opacity: 0.5;
  z-index: 100000000;
  display: flex;
  justify-content: center;
  align-items: center;
}

#svg-spinner {
  -webkit-transition-property: -webkit-transform;
  -webkit-transition-duration: 1.2s;
  -webkit-animation-name: rotate;
  -webkit-animation-iteration-count: infinite;
  -webkit-animation-timing-function: linear;

  -moz-transition-property: -moz-transform;
  -moz-animation-name: rotate;
  -moz-animation-duration: 1.2s;
  -moz-animation-iteration-count: infinite;
  -moz-animation-timing-function: linear;

  transition-property: transform;
  animation-name: rotate;
  animation-duration: 1.2s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
}

@-webkit-keyframes rotate {
  from {
    -webkit-transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(360deg);
  }
}

@-moz-keyframes rotate {
  from {
    -moz-transform: rotate(0deg);
  }
  to {
    -moz-transform: rotate(360deg);
  }
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>


// WEBPACK FOOTER //
// src/components/common/global-dialogs/SpinnerLoading.vue